import { gql } from '@efficiently/client-core-graphql-models';

export const SUBMIT_PROJECT_DESIGN_CHANGE_TO_GC = gql(`
	mutation SubmitProjectDesignChangeToGc($_id: ID!, $gcStakeholderId: ID!) {
		submitProjectDesignChangeToGC(_id: $_id, gcStakeholderId: $gcStakeholderId) {
			...ProjectDesignChangeDetail
		}
	}
`);
